export default __webpack_public_path__ + "static/dandelion-4e3157a4cd90b16c4cb81b0d238871e0.png";